/* eslint-disable */
import React from 'react';
import TalkExperts from '../components/TalkExperts/TalkExperts';
const InvestmentQuoteFooter = (props) => {
    function createURL(url) {
        try {
            const hostv = "https://www."
            return hostv + url.replace("https://", "").replace("www.", "").replace("http://", "").replace("//", "");
        } catch (err) {
            return "";
        }
    }
    return (
            <div className="row">
                {/* <div className="col-md-6 mt-4">
                    <div id="NoresultId">
                        <p><strong>Currently not getting the response from following insurers</strong></p>
                        {
                            props.ListItem.map((row,index) =>
                                <img key={index} src={props.IsLoader ? row.src : createURL(row.insurerLogo)} className="m-2" />
                            )}
                        <p className="Q_errMSG">Your location or vehicle model/age is not serviced by the insurer OR insurer is not reachable to provide live quotes currently.</p>
                    </div>
                </div> */}
                <div className="col-md-6 mt-4">
                    <TalkExperts mobile={props.MobileNu} prefertime={props.prefertime} EnquiryTypeList={props.EnquiryTypeList} />
                </div>
                <div className="col-md-6 mt-4">
                    <div className="DYKnow">
                        <div className="DYK">
                        <div className="DYKimg">
                            <img src={require("../Investment/Images/Do-You-Know.svg").default} alt="" />
                            </div>
                            <div className="DYKContent">
                                <div className="DYKTxt">
                                    <h3>Do you know?</h3>
                                </div>
                            <p className="DYKPara">Section 80C in the Income Tax Act of 1961 gives you the green light to trim up to Rs 1.5 lakh from your taxable income by investing in a variety of options. The majority of investment choices fall under this section's umbrella.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}
export default InvestmentQuoteFooter;